$(document).ready(function () {
    initiateSelectYourRegionPage();
    var languageSelector = $("#language_select");
    $("[data-js-language-selector]").on("click", function() {
        // hide search if open
        $("#header_search").removeClass("open");
        $("#language_select").slideToggle("400");
        $("body").toggleClass("fs-lang-open");

         // Focus on overlay on language selector
        setTimeout(function(){
            $(".language-select__regions-wrap > .language-select__header").focus();
        },0);

        // esc to dismiss overlay
        $(document).on('keydown', function (e) {
            if (e.which === 27) { // ESC
                $("#language_select").fadeOut(200);
                $("body").removeClass("fs-lang-open");
                returnLastElementFocus();
            }
        });
    });

    $("[data-js-language-select-close]").on("click", function(e) {
        e.preventDefault();

        $("#language_select").fadeOut(200);
        $("body").removeClass("fs-lang-open");
    });

    let selectedCountry = null;
    let selectedContinent = null;

    // Select Region
    $(".language-select__region").on("click", function (evt) {

        var zone = $(this).data("zone");
        if(!$('#language-select__countries #language_select_region_' + zone).length){

            $('#language-select__countries').append('<div id="language_select_region_' + zone +'" class="language-select__countries" data-zone="' + zone + '"><a href="" class="language-select__country-title">' + $(this).text() + '</a><ul class="language-select__country-container"></ul></div>');

            var selectedZone = ZONES.find(findByCode, zone);
            selectedZone.regions.forEach(function(region){
            if (!globalNavigationHideCountryList || !globalNavigationHideCountryList.includes(region.code)) {
            	if(region.hasOwnProperty("locations")){
            		$('#language_select_region_' + zone + ' ul').append('<li class="language-select-subregion">\n' +
                            '                                                       <a href="#" class="language-select-subregion-name" data-region="' + region.code + '">' + localText["text.selectYourRegion.region." + region.name.replace(/ /g,"").toLowerCase()] + '</a>\n' +
                            '                                                   </li>\n')
            	}else {
            		$('#language_select_region_' + zone + ' ul').append('<li class="language-select__country">\n' +
                            '                                                       <a href="#" class="language-select__country-name" data-region="' + region.code + '">' + localText["text.selectYourRegion.region." + region.name.replace(/ /g,"").toLowerCase()] + '</a>\n' +
                            '                                                   </li>\n')
            	}
              }
            });

            if(selectedZone.regions.length > 6 && selectedZone.regions.length % 6 !== 0){
                var emptyLis = 6 - selectedZone.regions.length % 6;
                for (var i = 0; i < emptyLis; i++){
                    $('#language_select_region_' + zone + ' ul').append('<li class="language-select__country">\n' +
                        '                                                       <a href="#" class="language-select__country-name" data-region=""></a>\n' +
                        '                                                   </li>\n')
                }
            }
        }

        $(".language-select__country-name").removeClass("active");
        $(".language-select-subregion-name").removeClass("active");
        $(".language-select__region").removeClass("active");
        $(".continent").remove();
        $(".language-select__region").removeAttr("role");
        $(".language-select__locations").removeClass("active");
        $(".language-select__languages").removeClass("active");
        $(".language-select__regions-wrap").addClass("inactive");
        $(".language-select__countries").removeClass("active");
        $(this).addClass("active");
        $(this).attr('role','status');
        $(this).append('<span class="sr-only continent">'+localText["linkgen.button.selected"]+'</span>');

        $(".language-select__countries[data-zone='" + zone + "']").addClass("active");

        $('.language-select__countries-row-wrap').removeClass("active").removeClass("inactive");
        $('.language-select__language-row-wrap').removeClass("active").removeClass("inactive");
        $('.language-select__locations-row-wrap').removeClass("active").removeClass("inactive");
        $('.language-select__countries-row-wrap').addClass("active");

        // get the total height of the children
        var height = 300; // country select header is 300px
        $(".language-select__countries[data-region='" + zone + "'] .language-select__country-container").each(function( index ) {
            height += $(this).height();
        });

        $(".language-select__wrapper").css("height", '100%');

        // Select Country
	    $(".language-select__country .language-select__country-name").on("click", function (e) {
	    	var region = $(this).data("region");
            var selectedRegion = regionMap.get(region);
            if(!selectedRegion.languages){
                window.location = selectedRegion.url;
                return;
            } else if(Object.values(selectedRegion.languages).length < 2){
                window.location = Object.values(selectedRegion.languages)[0].url;
                return;
            } else if (!$('#language-select__language #language_select_language_' + region).length) {
                $('#language-select__language').append('<div id="language_select_language_' + region + '" class="language-select__languages" data-region="' + region + '"><a href="" class="language-select__language-title">' + $(this).text() + '</a><ul class="language-select__language-container"></ul></div>');


                Object.values(selectedRegion.languages).forEach(function (language) {
                    $('#language_select_language_' + region + ' ul').append('<li class="language-select__language">\n' +
                        '                                                       <a href="#" class="language-select__language-name" onclick="marketChangeAction(\'' + language.url + '\', '+language.hasEcommEnv+')" >' + language.name + '</a>\n' +
                        '                                                     </li>\n');
                });
            }

             // Save the selected country before moving to language for SHIFT+TAB back tracking.
            setTimeout(function(){
                selectedCountry = e.target;
                $("#language-select__language > h2").focus();         
            },2000);

	        $(".language-select__locations ").removeClass("active");
            $(".language-select__country-name").removeClass("active");
            $(".region").remove();
            $(".language-select__country-name").removeAttr("role");
            $(".language-select__countries-row-wrap").addClass("inactive"); //.removeClass("active");
            $(".language-select-subregion-name").removeClass("active");
            $('.language-select__locations-row-wrap').removeClass("active").removeClass("inactive");
            $(".language-select__languages").removeClass("active");
            $(".language-select__country-name[data-region='" + selectedRegion.code + "']").addClass("active");
            $(".language-select__languages[data-region='" + region + "']").addClass("active");
            // $(".language-select__region[data-zone=]")
            $('.language-select__language-row-wrap').addClass("active");
            $(this).addClass("active");
            $(this).attr('role','status');
            $(this).append('<span class="sr-only region">'+localText["linkgen.button.selected"]+'</span>');
            // get the total height of the children
            var height = 300; // country select header is 300px
            $(".language-select__languages[data-region='" + region + "'] .language-select__language-container").each(function( index ) {
                height += $(this).height();
            });

            $(".language-select__wrapper").css("height", '100%');
            if(languageSelector.width() < 480){
                $(".language-select__wrapper").scrollTop(0);
            } else {
                languageSelector.scrollTop(languageSelector.height());
            }


            // go back a level from language
            $(".language-select__language-title").on("click", function (e) {
                e.preventDefault();
                e.stopPropagation();


                $('.language-select__language-row-wrap').removeClass("active");
                if(!$('.language-select__locations-row-wrap').hasClass('active')){
                    $('.language-select__countries-row-wrap').removeClass("inactive");
                }
                $(".language-select__languages").removeClass("active");
                //$(".language-select__regions-wrap").removeClass("inactive");
                //$(".language-select__countries").removeClass("active");
                $(".language-select__wrapper").css("height", "100%");

            });

            $(".language-select__state-title").on("click", function (e) {
                e.preventDefault();
                e.stopPropagation();
                $(".language-select__countries").removeClass("active-child");
                //$(".language-select__states").removeClass("active");
            });
        });

        // go back a level
        $(".language-select__country-title").on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();

            $('.language-select__countries-row-wrap').removeClass("active");
            $(".language-select__languages").removeClass("active");
            $(".language-select__regions-wrap").removeClass("inactive");
            $(".language-select__countries").removeClass("active");
            $(".language-select__wrapper").css("height", "100%");

        });

            // Select Country of Sub Region
            $(".language-select-subregion .language-select-subregion-name").on("click", function (e) {
                var region = $(this).data("region");
                var selectedRegion = regionMap.get(region);
                if (!$('#language-select__locations #language_select_location_' + selectedRegion.code).length) {

                $('#language-select__locations').append('<div id="language_select_location_' + selectedRegion.code +'" class="language-select__locations" data-region="' + selectedRegion.code + '"><a href="" class="language-select__location-title">' + $(this).text() + '</a><ul class="language-select__country-container"></ul></div>');
                selectedRegion.locations.forEach(function(location){
                	$('#language_select_location_' + selectedRegion.code + ' ul').append('<li class="language-select__country">\n' +
                                '                                                       <a href="#" class="language-select__country-name" data-location="' + location.code + '">' + localText["text.selectYourRegion.location." + location.name.replace(/ /g,"").toLowerCase()] + '</a>\n' +
                                '                                                   </li>\n')
                    });
                }

				$(".language-select__languages").removeClass("active");
				$(".language-select__country-name").removeClass("active");
                $(".region").remove();
                $('.language-select__country-name').removeAttr("role");
                $('.language-select__language-row-wrap').removeClass("active").removeClass("inactive");
                $('.language-select__countries-row-wrap').addClass("inactive");
                $(this).addClass("active");
                $(this).attr('role','status');
                $(this).append('<span class="sr-only region">'+localText["linkgen.button.selected"]+'</span>');

                $(".language-select__country-name[data-region='" + selectedRegion.code + "']").addClass("active");
                $('.language-select__locations-row-wrap').addClass("active");
                $(".language-select__locations[data-region='" + selectedRegion.code + "']").addClass("active");

                // get the total height of the children
                var height = 300; // country select header is 300px
                $(".language-select__locations[data-region='" + selectedRegion.code + "'] .language-select__location-container").each(function (index) {
                    height += $(this).height();
                });
                $(".language-select__wrapper").css("height", '100%');
                if (languageSelector.width() < 480) {
                    $(".language-select__wrapper").scrollTop(0);
                } else {
                    languageSelector.scrollTop(languageSelector.height());
                }

                setTimeout(function(){
                    selectedCountry = e.target;  
                    $("#language-select__locations > h2").focus(); 
                },2000);

                //Select Location
                $("#language-select__locations .language-select__country .language-select__country-name").on("click", function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    var region = $(this).data("location");
                    var selectedRegion = regionMap.get(region);
                    if (!selectedRegion.languages) {
                        window.location = selectedRegion.url;
                        return;
                    } else if (Object.values(selectedRegion.languages).length < 2) {
                        window.location = Object.values(selectedRegion.languages)[0].url;
                        return;
                    } else if (!$('#language-select__language #language_select_language_' + region).length) {
                        $('#language-select__language').append('<div id="language_select_language_' + region + '" class="language-select__languages" data-region="' + region + '"><a href="" class="language-select__language-title">' + $(this).text() + '</a><ul class="language-select__language-container"></ul></div>');


                        Object.values(selectedRegion.languages).forEach(function (language) {
                            $('#language_select_language_' + region + ' ul').append('<li class="language-select__language">\n' +
                                '                                                       <a href="#" class="language-select__language-name" onclick="marketChangeAction(\'' + language.url + '\', '+language.hasEcommEnv+')" >' + language.name + '</a>\n' +
                                '                                                     </li>\n');
                        });
                    }
                    $(".language-select__country-name").removeClass("active");
                    $(".language-select__countries-row-wrap").addClass("inactive"); //.removeClass("active");
                    $(".language-select__languages").removeClass("active");
                    $(".language").remove();
                    $('.language-select__languages').removeAttr("role");
                    $('.language-select__locations-row-wrap.active').addClass('inactive');
                    $('.language-select__language-row-wrap').removeClass("active").removeClass("inactive");
                    $(".language-select__languages[data-region='" + region + "']").addClass("active");
                    // $(".language-select__region[data-zone=]")
                    $('.language-select__language-row-wrap').addClass("active");
                    $(this).addClass("active");
                    $(this).attr('role','status');
                    $(this).append('<span class="sr-only language">'+localText["linkgen.button.selected"]+'</span>');
                    // get the total height of the children
                    var height = 300; // country select header is 300px
                    $(".language-select__languages[data-region='" + region + "'] .language-select__language-container").each(function (index) {
                        height += $(this).height();
                    });

                    $(".language-select__wrapper").css("height", '100%');
                    if(languageSelector.width() < 480){
                        $(".language-select__wrapper").scrollTop(0);
                    } else {
                        languageSelector.scrollTop(languageSelector.height());
                    }


                    // go back a level from language
                    $(".language-select__language-title").on("click", function (e) {
                        e.preventDefault();
                        e.stopPropagation();


                        $('.language-select__language-row-wrap').removeClass("active");
                        $('.language-select__locations-row-wrap.active').removeClass("inactive");
                        $(".language-select__languages").removeClass("active");
                        //$(".language-select__regions-wrap").removeClass("inactive");
                        //$(".language-select__countries").removeClass("active");
                        $(".language-select__wrapper").css("height", "100%");


                        $(".language-select__wrapper").css("height", '100%');
                        if (languageSelector.width() < 480) {
                            $(".language-select__wrapper").scrollTop(0);
                        } else {
                            languageSelector.scrollTop(languageSelector.height());
                        }
                    });


                    // go back a level from language
                    $(".language-select__language-title").on("click", function (e) {
                        e.preventDefault();
                        e.stopPropagation();


                        $('.language-select__language-row-wrap').removeClass("active");
                        $('.language-select__locations-row-wrap.active').removeClass("inactive");
                        $(".language-select__languages").removeClass("active");
                        //$(".language-select__regions-wrap").removeClass("inactive");
                        //$(".language-select__countries").removeClass("active");
                        $(".language-select__wrapper").css("height", "100%");

                    });

                    $(".language-select__state-title").on("click", function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        $(".language-select__countries").removeClass("active-child");
                        //$(".language-select__states").removeClass("active");
                    });
                });
                // go back a level
                $(".language-select__location-title").on("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    $('.language-select__locations-row-wrap').removeClass("active");
                    $(".language-select__languages").removeClass("active");
                    $(".language-select__countries-row-wrap").removeClass("inactive");
                    $(".language-select__locations").removeClass("active");
                    $('.language-select-subregion-name').removeClass('active');
                    $(".language-select__wrapper").css("height", "100%");

                });
            });
        // Save the selected continent before moving to country for SHIFT+TAB back event tracking.
        // Focus on sub-region selection
        setTimeout(function(){
            selectedContinent = evt.target;
            $("#language-select__countries > h2").focus();
        },2000)

    });
    
    $("#language-select__language > h2").bind('keydown focus', function(event){
        if(event.shiftKey && event.keyCode == 9) {
            if(selectedCountry != null) {
                setTimeout(function(){
                    selectedCountry.focus();
                },0);
            }
        }
    });

    $("#language-select__locations > h2").bind('keydown focus', function(event){
        if(event.shiftKey && event.keyCode == 9) {
            if(selectedCountry != null) {
                setTimeout(function(){
                    selectedCountry.focus();
                },0);
            }
        }
    });

    $("#language-select__countries > h2").bind('keydown focus', function(event){
        if(event.shiftKey && event.keyCode == 9) {
            if(selectedContinent != null) {
                setTimeout(function(){
                    selectedContinent.focus();
                },0);
            }
        }
    });

});

function initiateSelectYourRegionPage() {
    ZONES.sort(sortByOrderNum).map(function(zone) {
        $('#select-region').append('<button class="language-select__region" data-zone="' + zone.code + '">\n' +
            '                                    <div class="language-select__region-image">\n' +
            '                                        <span class="image ' + zone.code + '"></span>\n' +
            '                                    </div>\n' +
            '                                    <div class="language-select__region-name">' + localText["text.selectYourRegion.continent." + zone.code.replace(/-/g,"")] + '</div>\n' +
            '                       </button>');

        zone.regions = zone.regions.map(function(region){
            return Object.assign(REGIONS[region.code], region);
        });
        zone.regions.sort(sortByName);
    });
    regionMap = new Map(Object.keys(REGIONS).map(function(key){
        return [key, REGIONS[key]];
    }));
}

function sortByOrderNum(a, b){
    if(a.order < b.order) return -1;
    if(a.order > b.order) return 1;
    return 0;
}

function sortByName(a, b){
	aName=localText["text.selectYourRegion.region." + a.name.replace(/ /g,"").toLowerCase()];
	bName=localText["text.selectYourRegion.region." + b.name.replace(/ /g,"").toLowerCase()];
    if(a.code.includes("gac")) return 1; // Not Listed will always be last
    if(b.code.includes("gac")) return -1;
    if(aName < bName) return -1;
    if(aName > bName) return 1;
    return 0;
}

function findByCode(element){
    // This is referring to the additional parameter
    // given to the find function on the array
    return element.code == this.valueOf();
}
